/* istanbul ignore file */
import { SVGProps } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
const SvgElem = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} >
  <g>
    <g id="Layer_1">
      <path id="Path_3676" fill="currentColor" d="M1.6,45.1h39.6v-2.6H1.6v2.6ZM1.6,37.2h44.9v-2.6H1.6v2.6ZM1.6,29.3h44.9v-2.6H1.6v2.6ZM21.4,21.4h25.1v-2.6h-25.1v2.6ZM21.4,13.4h25.1v-2.6h-25.1v2.6ZM1.6,2.9v4h2.6v-1.3h4v13.2h-2.6v2.6h7.9v-2.6h-2.6V5.5h4v1.3h2.6v-4H1.6ZM21.4,5.5h25.1v-2.6h-25.1v2.6Z"/>
    </g>
  </g>

</svg>
);
export const LabelInstructions = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid={'LabelInstructionsIcon'}
    >
      <SvgElem {...props} />
    </SvgIcon>
  );
};
